import { graphql } from '~publish/graphql'
import type { ResultOf, VariablesOf } from '~publish/graphql'

export const SelectableTeamMembersQuery = graphql(/* GraphQL */ `
  query SelectableTeamMembersQuery(
    $input: SelectableTeamMembersInput!
    $first: Int
    $after: String
  ) {
    selectableTeamMembers(input: $input, first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          name
          urn
          avatar
          email
          isDeleted
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`)

export type SelectableTeamMember = ResultOf<
  typeof SelectableTeamMembersQuery
>['selectableTeamMembers']['edges'][number]['node']
export type TeamMemberScope = VariablesOf<
  typeof SelectableTeamMembersQuery
>['input']['scope']
